<template>
  <div class="container-fluid ">
    Page Not found
  </div>
</template>

<script>
import toast from '../services/toast';
import store from '../store/store';
import _ from 'lodash';

export default {
  name: "NotFound",
};
</script>
